import { Box, Stack } from '@chakra-ui/react';

import { CommonCellProps, DefaultContentCell } from './FeedContentCell';
import { ParticipantNameCell } from './ParticipantNameCell';

interface SubRowCellProperties extends CommonCellProps {
  participantName: string;
  createdAt: string;
  userId?: string;
  selectedMessageId?: string;
}

export const SubRowCell = ({
  participantName,
  threadId,
  createdAt,
  userId,
  content,
  editedAt,
  hidden,
  messageId,
  parentMessageContent,
  getCanExpand,
  getIsExpanded,
  toggleExpanded,
  subRowCount,
  participantView,
  selectedMessageId,
  selectedActivity,
  isGeneralDiscussion,
}: SubRowCellProperties) => {
  return (
    <Box
      bg={
        selectedMessageId
          ? messageId === selectedMessageId && threadId
            ? '#EBF8FF'
            : ''
          : 'keyops.gray50'
      }
      borderRadius="4px"
      p={3.5}
    >
      <Stack direction="row" gap={3}>
        <ParticipantNameCell
          filterByUserId={participantView}
          participantName={participantName}
          createdAt={createdAt}
          userId={userId}
        />
        <DefaultContentCell
          content={content}
          editedAt={editedAt}
          hidden={hidden}
          getCanExpand={getCanExpand}
          getIsExpanded={getIsExpanded}
          toggleExpanded={toggleExpanded}
          subRowCount={subRowCount}
          threadId={threadId}
          messageId={messageId}
          participantView={false}
          viewThreadModal={!!selectedMessageId}
          parentMessageContent={parentMessageContent}
          selectedActivity={selectedActivity}
          isGeneralDiscussion={isGeneralDiscussion}
        />
      </Stack>
    </Box>
  );
};
